import React, { Component, Fragment } from 'react';
import { translate } from '../../Services/translation';

// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
//
//      Do NOT forget to add the Website texts for the Generic Export:
//      '\Litium.Accelerator\Definitions\WebsiteTexts\CommonWebsiteTexts.cs'
//
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
class GenericExport extends Component {

    constructor(props) {
        super(props);
        this.state = {
            heading: '',
            startDate: '',
            showConfigName: false,
            showCustomerExportFieldsList: false,
            initCustomerExportFieldsList: false
        };
        this.clickHandler = this.clickHandler.bind(this);
    }

    componentDidUpdate() {
        if (this.props.exportObjects && this.props.exportObjects.length > 0 && this.props.activeObjectIndex !== -1) {
            const customerExportFieldName = this.props.exportObjects[this.props.activeObjectIndex].customerExportFieldName;
            if (this.state.customerExportFieldName !== customerExportFieldName) {
                this.setCultures();
                this.setState({
                    customerExportFieldName: customerExportFieldName
                });
            }
        }
    }

    setCultures() {
        if (this.props.exportObjects && this.props.exportObjects.length > 0 && this.props.activeObjectIndex !== -1) {
            const cultures = this.props.exportObjects[this.props.activeObjectIndex].cultures;
            const languages = document.getElementById('languagesSelect');
            if (languages) {
                Array.from(languages.options).forEach(function (option) {
                    option.selected = cultures.includes(option.value);
                });
            }
        }
    }

    componentDidMount() {
        document.addEventListener("click", this.clickHandler);
    }

    componentWillUnmount() {
        document.removeEventListener("click", this.clickHandler);
    }

    clickHandler(event) {
        const $scope = this;

        const { showCustomerExportFieldsList, initCustomerExportFieldsList } = $scope.state;
        if (initCustomerExportFieldsList) {
            return;
        }

        const el = document.getElementById('savedConfigListItems');
        if (showCustomerExportFieldsList && el && !el.contains(event.target)) {
            this.setState({
                showCustomerExportFieldsList: false
            });
        }
    }

    toggleCustomerExportFieldsList() {
        const $scope = this;
        const { showCustomerExportFieldsList } = this.state;
        this.setState({
            showCustomerExportFieldsList: !showCustomerExportFieldsList,
            initCustomerExportFieldsList: true
        });

        setTimeout(function () {
            $scope.setState({
                initCustomerExportFieldsList: false
            });
        },
            500);
    }

    toggleConfigName(checkboxEl) {
        const showConfigName = checkboxEl.checked;
        if (showConfigName) {
            const el = document.getElementById("showConfigName");
            if (el) {
                el.value = '';
            }
        }
        this.setState({
            showConfigName
        });
    }

    setLocalActiveExportFields(customerExportFieldName, activeObjectIndex, exportObj) {
        const { setActiveExportFields } = this.props;

        if (setActiveExportFields) {
            setActiveExportFields(customerExportFieldName, activeObjectIndex);
        }

        this.toggleCustomerExportFieldsList();
        this.props.initSelectedLanguages(exportObj ? exportObj.cultures : []);
    }

    localRemoveExportFields(customerExportFieldName, activeObjectIndex) {

        const removeField = confirm(translate('common.genericexport.exportfields.deletequestion') + ' \'' + customerExportFieldName + '\'');
        if (!removeField) {
            return;
        }
        const { removeExportFields } = this.props;

        if (removeExportFields) {
            removeExportFields(customerExportFieldName, activeObjectIndex);
        }

        this.toggleCustomerExportFieldsList();
    }

    render() {
        const { exportObjects, dataSources, selectedDataSources, areaTypeName, exportDone, onExport, addDataSource, setActiveType, activeType, activeObjectIndex, addFieldToCollection, removeSelectedDataSource, removeThisFieldInCollection, clearAllFieldsInCollection, setSelectedFieldType, closeGe, setActiveExportFields, languages, addSelectedLanguages, initSelectedLanguages } = this.props;
        const { showConfigName, showCustomerExportFieldsList } = this.state;
        const showFields = activeType &&
            exportObjects[activeObjectIndex].exportTypeName &&
            (exportObjects[activeObjectIndex].exportFields || exportObjects[activeObjectIndex].fileExportFields) &&
            exportObjects[activeObjectIndex].displayFields;
        const exportType = activeType ? exportObjects[activeObjectIndex].exportTypeName.toLowerCase() : "";
        const activeObj = activeObjectIndex || activeObjectIndex === 0 ? exportObjects[activeObjectIndex] : null;
        const showArticles = selectedDataSources &&
            selectedDataSources.find(obj => {
                return obj.id === 'Articles';
            });

        return <section className={exportDone ? 'generic-export__showing-info' : ''}>
            {exportDone &&
                <section className="generic-export__export-created-box"><div>{translate('common.genericexport.exportinitialized')}</div></section>
            }
            <div className="row">
                <button
                    onClick={closeGe}
                    className="generic-export__button--close">
                    <label>{translate('common.genericexport.button.close')}
                    </label>
                    <img src="../../../ui/images/export-delete-icon_1.svg" className="far button-delete-icon" /></button>
                <div className="small-12 columns">
                    <h2>{translate('common.genericexport.maintitle')} ({translate('common.genericexport.areatype.' + areaTypeName.toLowerCase())})</h2>
                </div>

                <div className="small-12 columns">
                    <div className="row">
                        <div className="small-12 medium-4 columns">
                            <section className="generic-export__data-sources">
                                <h5>{translate('common.genericexport.choosedatasources')}</h5>
                                <form>
                                    <select name="dataSource" onChange={addDataSource}>
                                        {dataSources.map((dataSource, dataSourceIndex) => {
                                            return (
                                                <option key={dataSource.id + dataSourceIndex} data-dindex={dataSourceIndex} value={dataSource.id} dangerouslySetInnerHTML={{ __html: dataSource.name }}></option>
                                            );
                                        })}
                                    </select>
                                </form>
                            </section>
                        </div>
                    </div>
                    {showArticles &&
                        <div className="row">
                            <div className="small-12 medium-4 columns">
                                <section className="generic-export__exportarticles">
                                    <h5>{translate('common.genericexport.exportarticles')}</h5>
                                    <form>
                                        <input id="exportArticles" className="exportarticles" type="text" />
                                    </form>
                                </section>
                            </div>
                        </div>
                    }

                    <div className="row">
                        {selectedDataSources &&
                            <ol className="generic-export__customerFieldDataList">
                                {selectedDataSources.map((selectedDataSource, selectedDataSourceIndex) => {
                                    return (
                                        <li key={selectedDataSource.id}><span dangerouslySetInnerHTML={{ __html: selectedDataSource.name }}></span><img src="../../../ui/images/export-delete-icon_1.svg" className="fas field-delete-icon" data-sourceindex={selectedDataSourceIndex} onClick={removeSelectedDataSource} /></li>
                                    );
                                })}
                            </ol>
                        }
                    </div>
                    <div className="row">
                        <div className="small-12 medium-4 columns">
                            <section className={showFields ? 'generic-export__set-export-object-type--active' : ''}>
                                <h5>{translate('common.genericexport.chooseexporttype')}</h5>
                                <form>
                                    <select onChange={setActiveType} name="exportObjectType" value={activeType}>
                                        <option value="">-----------</option>
                                        {exportObjects.map((exportObject, exportTypeIndex) => {
                                            return (
                                                <option key={'exportType' + exportTypeIndex} data-dindex={exportTypeIndex} value={exportObject.exportTypeName} >
                                                    {translate('common.genericexport.type.' + exportObject.exportTypeName.toLowerCase())}
                                                </option>
                                            );
                                        })}
                                    </select>
                                    {exportType === 'excel' && activeObj && activeObj.customerExportFieldsList && activeObj.customerExportFieldsList.length > 0 &&
                                        <Fragment>
                                            <div id="savedConfigListName" onClick={event => this.toggleCustomerExportFieldsList()} className="generic-export__saved-config-list-name">{activeObj.customerExportFieldName ? activeObj.customerExportFieldName : translate('common.genericexport.exportfields.choose')}</div>

                                            {showCustomerExportFieldsList &&
                                                <div id="savedConfigListItems" className="generic-export__saved-config-list-items" ref={this.selectSavedFieldsRef} onClick={this.handleClickInside}>
                                                    {activeObj.customerExportFieldName !== '' &&
                                                        <div onClick={event => this.setLocalActiveExportFields('', activeObjectIndex, null)}>{translate('common.genericexport.exportfields.all')}</div>
                                                    }
                                                    {activeObj.customerExportFieldsList.map((exportObject, fieldListIndex) => {
                                                        return (
                                                            <div onClick={event => this.setLocalActiveExportFields(exportObject.customerFieldsName, activeObjectIndex, exportObject)} key={`fieldList-${fieldListIndex}`}>{exportObject.customerFieldsName}
                                                                {showFields &&
                                                                    <Fragment>
                                                                        <div className="generic-export__delete-saved-customer-fields" onClick={event => this.localRemoveExportFields(exportObject.customerFieldsName, activeObjectIndex)}><i className="far fa-trash-alt"></i></div>
                                                                    </Fragment>
                                                                }</div>
                                                        );
                                                    })}
                                                </div>
                                            }
                                        </Fragment>
                                    }

                                </form>
                            </section>
                        </div>
                        {showFields &&
                            <div className="small-12 medium-8 columns">
                                <aside>
                                    <h3 className="generic-export__field-title">{translate('common.genericexport.choosefieldtitle')}</h3>
                                    <p>{translate('common.genericexport.choosefielddescription')}</p>
                                </aside>
                            </div>
                        }
                    </div>
                </div>
            </div>
            <div className="row data-panes">
                {exportObjects.map((exportObject, fieldIndex) => {
                    return (
                        <Fragment key={'field' + fieldIndex}>
                            {activeType === exportObject.exportTypeName && (exportObject.exportFields || exportObject.fileExportFields) && exportObject.displayFields &&
                                <div className="small-12 columns">
                                    <div className="row">
                                        <div className="small-12 medium-4 columns">
                                            <section className="generic-export__data-languages">
                                                <h5>{translate("common.genericexport.choose.languages")}</h5>
                                                <form>
                                                    <select id="languagesSelect" name="dataSource" multiple onChange={addSelectedLanguages}>
                                                        {languages.map((dataSource, dataSourceIndex) => {
                                                            if (dataSourceIndex === 0) {
                                                                return <option key={translate(dataSource.name) + dataSourceIndex
                                                                } data-dindex={dataSourceIndex} value={translate(dataSource.cultureName)} dangerouslySetInnerHTML={{ __html: translate(dataSource.name) }}></option>;
                                                            } else {
                                                                return (
                                                                    <option key={dataSource.name + dataSourceIndex} data-dindex={dataSourceIndex} value={dataSource.cultureName} dangerouslySetInnerHTML={{ __html: dataSource.name }}></option>
                                                                );
                                                            }
                                                        })}
                                                    </select>
                                                </form>
                                            </section>
                                        </div>
                                    </div>
                                    <section className="generic-export__choose-field-container">
                                        <section className="generic-export__choose-field-container-data">
                                            <hr />
                                            {exportObject.customerExportFields && exportObject.customerExportFields.length > 0 &&
                                                <Fragment>
                                                    <button onClick={clearAllFieldsInCollection} data-objectindex={fieldIndex} className="button generic-export__button generic-export__choose-field-container-data-button--clear">{translate('common.genericexport.button.clearallfields')} <i className="far fa-trash-alt"></i></button>
                                                </Fragment>
                                            }

                                            {exportObject.customerExportFields && exportObject.customerExportFields.length > 0 ? (
                                                <Fragment>
                                                    <ul className="generic-export__customerFieldDataList">
                                                        {
                                                            exportObject.customerExportFields.map((customerField, customerFieldsIndex) => {
                                                                let custField = "";
                                                                let fixedValue = "";
                                                                let calculationValue = "";
                                                                const exportObjectNameLeft = customerField.fieldDataLeft && customerField.fieldDataLeft.exportObjectName ? customerField.fieldDataLeft.exportObjectName : "";
                                                                const exportObjectNameRight = customerField.fieldDataRight && customerField.fieldDataRight.exportObjectName ? customerField.fieldDataRight.exportObjectName : "";
                                                                if (exportType === 'excel') {
                                                                    let custFieldClean = "";

                                                                    const description1 = customerField.fieldDataLeft.exportFieldDescription ? customerField.fieldDataLeft.exportFieldDescription : "";
                                                                    const description2 = customerField.fieldDataRight.exportFieldDescription ? customerField.fieldDataRight.exportFieldDescription : "";

                                                                    const fullDescription = description1 + description2;
                                                                    custField = custFieldClean = "<i>" + (fullDescription ? "<label>" + fullDescription + "</label>" : "") + exportObjectNameLeft;

                                                                    const sizeString = customerField.fieldDataLeft.exportObjectType === 'MediaPointerImage' ? (' (' + (customerField.fieldDataLeft.exportObjectImageWidth.length > 0 ? customerField.fieldDataLeft.exportObjectImageWidth : 'auto') + ' * ' + (customerField.fieldDataLeft.exportObjectImageHeight.length > 0 ? customerField.fieldDataLeft.exportObjectImageHeight : 'auto') + ')') : '';
                                                                    custField += sizeString;

                                                                    if (customerField.fieldDeliminator) {
                                                                        custField += " " + customerField.fieldDeliminator + " ";
                                                                        custFieldClean += " " + customerField.fieldDeliminator + " ";
                                                                    }
                                                                    if (exportObjectNameRight) {
                                                                        custField += exportObjectNameRight;
                                                                        custFieldClean += exportObjectNameRight;
                                                                    }
                                                                    if (customerField.fieldCalculationValue) {
                                                                        calculationValue = "</i> <b>&nbsp;" + translate('common.genericexport.fields.title.calculationvalue') + ":</b> <i>" + customerField.fieldCalculationValue;
                                                                    }
                                                                    if (customerField.fieldFixedValue && customerField.fieldFixedValue.exportFieldValue) {
                                                                        fixedValue = "</i> <b>&nbsp;" + customerField.fieldFixedValue.exportFieldDescription + ":</b> <i>" + customerField.fieldFixedValue.exportFieldValue;
                                                                    }
                                                                    let header = "</i> <b>&nbsp;" + translate('common.genericexport.titlestring') + ":</b> <i>";
                                                                    if (customerField.fieldHeading) {
                                                                        header += customerField.fieldHeading;
                                                                    }
                                                                    else {
                                                                        header += custFieldClean;
                                                                    }
                                                                    custField += header + "</i>";
                                                                    const imageString = customerField.fieldDataLeft.exportObjectType === 'MediaPointerImage' ? '<i class="far fa-image"></i>' : '';
                                                                    custField = customerField.sortOrder + " " + imageString + "<b>" + translate('common.genericexport.fields.title.field') + ":</b> " + custField;

                                                                } else {
                                                                    custField = "<i>" + (exportObjectNameLeft) + "</i>";
                                                                    custField = "<b>&nbsp;" + translate('common.genericexport.fields.title.field') + ":</b> " + custField;
                                                                }

                                                                return (
                                                                    <li key={'customerFields' + customerFieldsIndex}><span dangerouslySetInnerHTML={{ __html: custField + fixedValue + calculationValue }}></span><img src="../../../ui/images/export-delete-icon_1.svg" className="fas field-delete-icon" data-fieldindex={customerFieldsIndex} data-objectindex={fieldIndex} onClick={removeThisFieldInCollection} /></li>
                                                                );
                                                            })
                                                        }
                                                    </ul>
                                                    <hr />
                                                </Fragment>) : (
                                                exportType === 'excel' &&
                                                <div className="generic-export__choose-field-container--no-fields-chosen">{translate('common.genericexport.nofieldscosen')}</div>
                                            )
                                            }
                                        </section>
                                        <form className="generic-export__form generic-export__form--fields">
                                            <input type="hidden" name="exportObjectIndex" value={fieldIndex} />
                                            <div className="row show-for-large">
                                                <div className="small-12 large-10 columns">
                                                    <div className="row">
                                                        <div className="small-12 large-1 columns"><h5>{translate('common.genericexport.fields.title.sortorder')}</h5></div>
                                                        <div className="small-12 large-2 columns"><h5>{translate('common.genericexport.fields.title.field')}</h5></div>
                                                        {exportType === 'excel' &&
                                                            <Fragment>
                                                                {exportObject.activeFieldType !== "MediaPointerImage" ? (
                                                                    <Fragment>
                                                                        <div className="small-12 large-2 columns"><h5>{translate('common.genericexport.fields.title.delimiter')}</h5></div>
                                                                        <div className="small-12 large-2 columns"><h5>{translate('common.genericexport.fields.title.field')}</h5></div>
                                                                    </Fragment>
                                                                ) : (
                                                                    <Fragment>
                                                                        <div className="small-12 large-1 columns"></div>
                                                                        <div className="small-12 large-2 columns"><h5>{translate('common.genericexport.fields.title.imagewidth')}</h5></div>
                                                                        <div className="small-12 large-2 columns"><h5>{translate('common.genericexport.fields.title.imageheight')}</h5></div>
                                                                    </Fragment>
                                                                )}
                                                                <div className="small-12 large-1 columns"><h5>{translate('common.genericexport.fields.title.calculationvalue')}</h5></div>
                                                                <div className="small-12 large-1 columns"><h5>{translate('common.genericexport.fields.title.fixedvalue')}</h5></div>
                                                                <div className="small-12 large-2 columns"><h5>{translate('common.genericexport.fields.title.heading')}</h5></div>
                                                            </Fragment>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="small-12 large-10 columns">
                                                    <div className="row">
                                                        <div className="small-12 large-1 columns">
                                                            <label className="hide-for-large">{translate('common.genericexport.fields.title.sortorder')}</label>
                                                            <input type="text" className="sortorder" name="sortOrder" />
                                                        </div>
                                                        <div className="small-12 large-2 columns">
                                                            <label className="hide-for-large">{translate('common.genericexport.fields.title.field')}</label>
                                                            <select name="fieldDataLeft" data-objectindex={fieldIndex} onChange={setSelectedFieldType}>
                                                                <option value="">----</option>
                                                                {exportType === 'excel' && exportObject.exportFields.length > 0 && exportObject.exportFields.map((exportField, fieldNameLeftIndex) => {

                                                                    return (
                                                                        <option key={'fieldNameLeft' + fieldNameLeftIndex} data-id={exportField.exportObjectId} data-type={exportField.exportObjectType} data-isbaseproduct={exportField.isBaseProduct} data-description={exportField.exportFieldDescription} value={exportField.exportObjectName} className={!exportField.isBaseProduct ? 'is-variant' : ''}>
                                                                            {exportField.exportObjectName}
                                                                        </option>
                                                                    );
                                                                })}

                                                                {exportType === 'files' && exportObject.fileExportFields.length > 0 && exportObject.fileExportFields.map((exportField, fieldNameLeftIndex) => {

                                                                    return (
                                                                        <option key={'fieldNameLeft' + fieldNameLeftIndex} data-id={exportField.exportObjectId} data-type={exportField.exportObjectType} data-description={exportField.exportFieldDescription} value={exportField.exportObjectName}>
                                                                            {exportField.exportObjectName}
                                                                        </option>
                                                                    );
                                                                })
                                                                }
                                                            </select>

                                                        </div>
                                                        {exportType === 'excel' &&
                                                            <Fragment>
                                                                {exportObject.activeFieldType !== "MediaPointerImage" ? (
                                                                    <Fragment>
                                                                        <div className="small-12 large-2 columns">
                                                                            <label className="hide-for-large">{translate('common.genericexport.fields.title.delimiter')}</label>
                                                                            <input type="text" className="delimiter" name="fieldDeliminator" maxLength="4" />
                                                                        </div>
                                                                        <div className="small-12 large-2 columns">
                                                                            <label className="hide-for-large">{translate('common.genericexport.fields.title.field')}</label>
                                                                            <select name="fieldDataRight">
                                                                                <option value="">----</option>
                                                                                {exportObject.exportFields.length > 0 && exportObject.exportFields.map((exportField, fieldNameRightIndex) => {
                                                                                    return (
                                                                                        <option key={'fieldNameRight' + fieldNameRightIndex} data-id={exportField.exportObjectId} data-type={exportField.exportObjectType} data-isbaseproduct={exportField.isBaseProduct} data-description={exportField.exportFieldDescription} value={exportField.exportObjectName} className={!exportField.isBaseProduct ? 'is-variant' : ''}>
                                                                                            {exportField.exportObjectName}
                                                                                        </option>
                                                                                    );
                                                                                })
                                                                                }
                                                                            </select>
                                                                        </div>
                                                                    </Fragment>
                                                                ) : (
                                                                    <Fragment>
                                                                        <div className="small-12 large-1 columns"><i className="far fa-image"></i></div>
                                                                        <div className="small-12 large-2 columns"><label className="hide-for-large">{translate('common.genericexport.fields.title.imagewidth')}</label><input type="number" className="generic-export__image-size" name="imageWidth" maxLength="3" placeholder={translate('common.genericexport.fields.title.imagewidth')} /></div>
                                                                        <div className="small-12 large-2 columns"><label className="hide-for-large">{translate('common.genericexport.fields.title.imageheight')}</label><input type="number" className="generic-export__image-size" name="imageHeight" maxLength="3" placeholder={translate('common.genericexport.fields.title.imageheight')} /></div>
                                                                    </Fragment>
                                                                )}
                                                                <div className="small-12 large-1 columns">
                                                                    <label className="hide-for-large">{translate("common.genericexport.fields.title.calculationvalue")}</label>
                                                                    <input type="number" step="any" className="title" name="fieldCalculationValue" />
                                                                </div>
                                                                <div className="small-12 large-1 columns">
                                                                    <label className="hide-for-large">{translate("common.genericexport.fields.title.fixedvalue")}</label>
                                                                    <input type="text" className="title" name="fieldFixedValue" />
                                                                </div>
                                                                <div className="small-12 large-2 columns">
                                                                    <label className="hide-for-large">{translate('common.genericexport.fields.title.heading')}</label>
                                                                    <input type="text" className="title" name="fieldHeading" placeholder={translate('common.genericexport.fields.title.heading')} />
                                                                </div>
                                                            </Fragment>
                                                        }
                                                    </div>
                                                </div>
                                                <div className="small-12 large-2 columns">
                                                    <input type="button" onClick={addFieldToCollection} className="button generic-export__button generic-export__choose-field-container-data-button--add" value={translate('common.genericexport.button.addfield')} />
                                                </div>
                                            </div>
                                        </form>
                                    </section>
                                </div>
                            }
                        </Fragment>
                    );
                })
                }

                {exportObjects.map((exportObject, jobIndex) => {
                    return (
                        <Fragment key={'job' + jobIndex}>
                            {activeType === exportObject.exportTypeName &&
                                <section className="small-12 columns generic-export__export-area" >
                                    <form className="generic-export__form">
                                        <input type="hidden" name="exportObjectIndex" value={jobIndex} />
                                        <div className="row">
                                            <div className="small-12 medium-6 columns">
                                                <h5>{translate('common.genericexport.choosetemplate')} - ({translate('common.genericexport.type.' + exportObject.exportTypeName.toLowerCase())})</h5>
                                                <select name="exportObjectTemplate" className="exportObjectTemplate" onChange={event => this.setHeading(event.target.options[event.target.selectedIndex].text)}>
                                                    {
                                                        exportObject.templates.map((template, exportJobIndex) => {
                                                            return (
                                                                <option key={'exportJob' + exportJobIndex} data-method={template.method} data-type={template.exportResponseType} value={exportObject.exportTypeName}>
                                                                    {translate(template.exportNameWebsiteString.toLowerCase())}
                                                                </option>
                                                            );
                                                        })
                                                    }
                                                </select>
                                            </div>
                                            <div className="small-12 medium-6 columns">
                                                {exportType === 'excel' && showFields &&
                                                    <Fragment>
                                                        <span className="generic-export__form--store-fields">{translate('common.genericexport.description.checkbox.storefields')}</span>
                                                        {showConfigName &&
                                                            <input id="customerFieldsName" className="generic-export__new-config-name" type="text" placeholder={translate('common.genericexport.exportfields.choosename')} />
                                                        }
                                                    </Fragment>
                                                }
                                                <input type="button" onClick={onExport} className={!showFields ? 'button generic-export__button no-fields' : 'button generic-export__button'} value={translate('common.genericexport.button.export') + ' ' + translate('common.genericexport.type.' + exportObject.exportTypeName.toLowerCase())} />
                                                {exportType === 'excel' && showFields &&
                                                    <input id="saveCustomerFields" type="checkbox" onClick={event => this.toggleConfigName(event.target)} />
                                                }
                                            </div>
                                        </div>
                                    </form>
                                </section>
                            }
                        </Fragment>
                    );
                })
                }
            </div >
            <div id="genericLoader" className="generic-loader" />
        </section >;
    }
}
export default GenericExport;